import React, {useContext} from 'react'
import { components, constants, useTranslation, useServices } from 'cng-web-lib'
import Namespace from 'src/constants/locale/Namespace'
import ManifestKeys from 'src/constants/locale/key/AceHighwayManifest'
import Box from '@material-ui/core/Box'
import AceHighwayManifestApiUrls from 'src/apiUrls/AceHighwayManifestApiUrls'
import EmailCoverSheetFormProperties from './EmailCoverSheetFormProperties'
import { FileForUserGetCurrentLoginId } from 'src/common/FileForUserCommon'
import ACEHighwayManifestTranslationText from './../contexts/ACEHighwayManifestTranslationText'

const {
  button: { CngButton },
  form: {
   CngForm
  },
  CngDialog,
} = components

const { FormState } = constants

function EmailCoverSheetDialog(props) {
  const {
    openDialog,
    onClose,
    showNotification
  } = props

  const { initialValues, makeValidationSchema } = EmailCoverSheetFormProperties.formikProps
  const {securedSendRequest } = useServices()
  const aceHighwayManifestTranslationText = ACEHighwayManifestTranslationText() 
  /*const { translate } = useTranslation(Namespace.ACEHWY_MANIFEST)
  const translatedTextsObject = makeTranslatedTextsObject()

  function makeTranslatedTextsObject() {
    let emailTitle = translate(
      Namespace.ACE_HIGHWAY_MANIFEST,
      ManifestKeys.EMAIL_COVERSHEET
    )

    let sendButton = translate(
      Namespace.ACE_HIGHWAY_MANIFEST,
      ManifestKeys.SEND_BUTTON
    )

    let sendCoverSheetSuccessMsg = translate(
      Namespace.ACE_HIGHWAY_MANIFEST,
      ManifestKeys.SEND_COVER_SHEET_SUCCESS_MSG
    )

    let sendCoverSheetFailedMsg = translate(
      Namespace.ACE_HIGHWAY_MANIFEST,
      ManifestKeys.SEND_COVER_SHEET_FAILED_MSG
    )

    return { emailTitle, sendButton, sendCoverSheetSuccessMsg, sendCoverSheetFailedMsg }
  }*/

  function handleEmailCoverSheet(data){
    try {
      securedSendRequest.execute(
        'POST',
        AceHighwayManifestApiUrls.EMAIL_COVERSHEET,
        data,
        (response) => {
          if (response.status === 200) {
            if (response.data) {
              const errorMessages = response.data.errorMessages

              if (!errorMessages) {
                showNotification(
                  'success',
                  aceHighwayManifestTranslationText.sendCoverSheetSuccessMsg
                )
                onClose()
              } else {
                errorMessages.forEach((message) =>
                  showNotification('error', message)
                )
              }
            }
          }
        },
        () => {
          showNotification('error', aceHighwayManifestTranslationText.sendCoverSheetFailedMsg)
        }
      )
    } catch (error) {
      console.log(error)
    }
  }

  return (
    <CngDialog
      dialogContent={
        <CngForm
          formikProps={{
            initialValues: {
              ...(initialValues)
            },
            makeValidationSchema: makeValidationSchema,
            onSubmit: (data) => {
                data.tripNo = openDialog.data && openDialog.data.tripNo
                data.partyId = openDialog.data && openDialog.data.partyId
                data.userId = FileForUserGetCurrentLoginId()
                data.includeQRCode = openDialog.data && openDialog.data.includeQRCode
                handleEmailCoverSheet(data)
                onClose()
            }
          }}
          formState={FormState.COMPLETED}
          renderBodySection={(labelMap, shouldHideMap) => (
            <EmailCoverSheetFormProperties.Fields
              showNotification={showNotification}
              shouldHideMap={shouldHideMap}
              tripNo={openDialog.data && openDialog.data.tripNo}
            />
          )}
          renderButtonSection={() => (
            <Box display='flex' justifyContent='flex-end'>
              <CngButton color='primary' size='medium' type='submit'>
                {aceHighwayManifestTranslationText.sendButton}
              </CngButton>
            </Box>
          )}
        />
      }
      dialogTitle={aceHighwayManifestTranslationText.emailTitle}
      // fullWidth
      // maxWidth='md'
      onClose={(_, reason) => {
        if (reason !== 'backdropClick') {
          onClose()
        }
      }}
      open={openDialog.open}
      shouldShowCloseButton
    />
  )
}

export default EmailCoverSheetDialog
